"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoIconWorker = exports.ADD_JOB = exports.INVALID_RESULT = exports.getWindow = void 0;
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/consistent-type-definitions */
var turf_1 = require("@turf/turf");
var geojson_to_svg_1 = __importDefault(require("geojson-to-svg"));
var lodash_1 = require("lodash");
var proj4_1 = __importDefault(require("proj4"));
var GeoThumbnailWorker_helpers_1 = require("./GeoThumbnailWorker.helpers");
require("./modules");
var getWindow = function () { return window; };
exports.getWindow = getWindow;
var proj4 = proj4_1.default;
exports.INVALID_RESULT = '<svg viewBox="Infinity Infinity -Infinity -Infinity" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.2"><g></g></svg>';
exports.ADD_JOB = "add_job";
/**
 * GeoIconWorker is a class that we use to create non-blocking SVGs from GeoJSON.
 * Despite its name, it's not creating an actual web worker or anything. What it does is attach two intervals to window:
 * workerInterval: processes items
 * resultWorkerInterval: sends results
 */
var GeoIconWorker = /** @class */ (function () {
    function GeoIconWorker() {
        var _this = this;
        /**
         * The pending job queue.
         */
        this.queue = [];
        /**
         * The finished job queue
         */
        this.resultQueue = [];
        /**
         * How often to pull pending jobs.
         */
        this.batchInterval = 200;
        /**
         * How many pending jobs to pull.
         */
        this.batchSize = 20;
        /**
         * How many results to pull.
         */
        this.resultBatchSize = 10;
        /**
         * How often to call resultTick
         */
        this.resultBatchInterval = 200;
        /**
         * The numeric id of the workerInterval attached to window.
         */
        this.workerInterval = 0;
        /**
         * The numeric id of the resultWorkerInterval attached to window.
         */
        this.resultWorkerInterval = 0;
        /**
         * When the resultWorkerInterval ticks, pull batchSize jobs off the queue and process them.
         * @calls processMessage for each item it pulls from the queue.
         * @calls stopWorker once the queue is empty.
         */
        this.workerTick = function () { return __awaiter(_this, void 0, void 0, function () {
            var i, msg, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < this.batchSize)) return [3 /*break*/, 6];
                        if (!this.queue.length) {
                            this.stopWorker();
                            return [3 /*break*/, 6];
                        }
                        msg = this.queue.shift();
                        if (!msg) return [3 /*break*/, 5];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.processMessage(msg)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        i += 1;
                        return [3 /*break*/, 1];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Pulls resultBatchSize results from the resultQueue.
         * @calls onmessage for each result.
         * If onmessage doesn't exist, then the job will silently complete.
         * So, be sure that you've assigned onmessage for yourself.
         */
        this.resultTick = function () {
            var msgs = _this.resultQueue.splice(0, _this.resultBatchSize);
            if (msgs.length) {
                msgs.forEach(function (msg) {
                    if (_this.onmessage) {
                        _this.onmessage({ data: msg });
                    }
                });
            }
            else {
                _this.stopResultWorker();
            }
        };
    }
    /**
     * A message in this case is GeoJSON to convert.
     * @calls startWorker, which will create the workerInterval.
     */
    GeoIconWorker.prototype.postMessage = function (msg) {
        this.queue.push(msg);
        this.startWorker();
    };
    /**
     * If no worker exists, this will attach an interval to window.
     * @calls workerTick every batchInterval milliseconds
     */
    GeoIconWorker.prototype.startWorker = function () {
        if (!this.workerInterval) {
            this.workerInterval = (0, exports.getWindow)().setInterval(this.workerTick, this.batchInterval);
        }
    };
    /**
     * Kill the workerInterval.
     */
    GeoIconWorker.prototype.stopWorker = function () {
        if (this.workerInterval) {
            (0, exports.getWindow)().clearInterval(this.workerInterval);
            this.workerInterval = 0;
        }
    };
    /**
     * If no resultWorkerInterval exists, this will attach an interval to window.
     * @calls resultTick every resultBatchInterval milliseconds.
     */
    GeoIconWorker.prototype.startResultWorker = function () {
        if (!this.resultWorkerInterval) {
            this.resultWorkerInterval = (0, exports.getWindow)().setInterval(this.resultTick, this.resultBatchInterval);
        }
    };
    /**
     * Kills the resultWorker.
     */
    GeoIconWorker.prototype.stopResultWorker = function () {
        if (this.resultWorkerInterval) {
            (0, exports.getWindow)().clearInterval(this.resultWorkerInterval);
            this.resultWorkerInterval = 0;
        }
    };
    /**
     * Calls handler functions depending on the job type.
     * Right now, it only does something if it's an "add job" message.
     * @todo Handle non–add job message.
     * @calls handleAddJob
     */
    GeoIconWorker.prototype.processMessage = function (msg) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = msg.type;
                        switch (_a) {
                            case exports.ADD_JOB: return [3 /*break*/, 1];
                        }
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.handleAddJob(msg)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        {
                            // todo
                        }
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Takes an add job message, converts it to an svg, and returns that.
     * When we process a job, we clear out all jobs with that id.
     * We _also_ update the SVG request to match the latest job in the queue, if we've received newer GeoJSON.
     * @example
        I add job A with id "foo" and shape "bar."
        I add some more jobs.
        I add job B with id "foo" and shape "baz."
        handleAddJob gets sent job A.
        It parses the queue and updates the request to the most recent, job B.
        handleAddJob returns an SVG for shape baz.
     * @calls postResult with the job's SVG
     */
    GeoIconWorker.prototype.handleAddJob = function (msg) {
        return __awaiter(this, void 0, void 0, function () {
            var mostRecentMatchingEntry, svgText;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mostRecentMatchingEntry = (0, lodash_1.findLast)(this.queue, function (job) { return job.id === msg.id; });
                        if (mostRecentMatchingEntry) {
                            msg = mostRecentMatchingEntry;
                        }
                        /**
                         * Clear all ADD_JOB jobs with this id from queue
                         */
                        this.queue = this.queue.filter(function (j) {
                            return j.type !== exports.ADD_JOB || j.id !== msg.id;
                        });
                        return [4 /*yield*/, this.render(msg.id, msg.shape)];
                    case 1:
                        svgText = _a.sent();
                        this.postResult(msg.id, svgText);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Pushes a result from handleAddJob into the result queue.
     * @calls startResultWorker to kick off result processing.
     */
    GeoIconWorker.prototype.postResult = function (id, result) {
        var msg = {
            id: id,
            result: result,
            success: !!result && result !== exports.INVALID_RESULT,
        };
        this.resultQueue.push(msg);
        this.startResultWorker();
    };
    GeoIconWorker.prototype.storeSVGInCache = function (shape, svg) {
        return __awaiter(this, void 0, void 0, function () {
            var hash;
            return __generator(this, function (_a) {
                try {
                    hash = (0, GeoThumbnailWorker_helpers_1.hashShape)(shape);
                    GeoThumbnailWorker_helpers_1.thumbnailStore.setItem(hash, svg);
                }
                catch (_b) {
                    console.error("Could not cache shape.");
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Converts a GeoJSON shape to an SVG
     * Uses geojson2svg and proj4, which have no typings, so _be careful if you touch this code_.
     */
    GeoIconWorker.prototype.render = function (id, shape) {
        return __awaiter(this, void 0, void 0, function () {
            var methods, multiplier, type, styles, data, styledFeatureArray, stylesById, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        methods = proj4(proj4.defs("WGS84"), proj4.defs("GOOGLE"));
                        multiplier = 0.01;
                        styles = {
                            Polygon: GeoThumbnailWorker_helpers_1.defaultStyles,
                            MultiPolygon: GeoThumbnailWorker_helpers_1.defaultStyles,
                        };
                        data = shape;
                        if ((0, GeoThumbnailWorker_helpers_1.shouldUseStyledShapes)(shape)) {
                            type = "styleId";
                            styledFeatureArray = (0, GeoThumbnailWorker_helpers_1.convertStyledShapeArrayToStyledFeatureArray)(Array.isArray(shape) ? shape : [shape], id);
                            stylesById = (0, GeoThumbnailWorker_helpers_1.getStylesById)(styledFeatureArray);
                            /**
                             * Still include default styles just in case something goes wrong
                             */
                            styles = __assign(__assign({}, styles), stylesById);
                            /**
                             * And we always render a FeatureCollection.
                             */
                            data = (0, turf_1.featureCollection)(styledFeatureArray.map(function (feature) { return feature.shape; }));
                        }
                        else if (Array.isArray(shape)) {
                            /**
                             * If there's more than one thing, we're making a FeatureCollection
                             */
                            data = (0, GeoThumbnailWorker_helpers_1.convertMixedShapeArrayToFeatureCollection)(shape, id);
                        }
                        else if (
                        /**
                         * If we don't have a Feature or FeatureCollection already, we make one here
                         */
                        data &&
                            "type" in data &&
                            data.type !== "Feature" &&
                            data.type !== "FeatureCollection") {
                            data = (0, GeoThumbnailWorker_helpers_1.ensureShapeIsMultiPolygonFeatureWithId)(data, id);
                        }
                        result = (0, geojson_to_svg_1.default)()
                            .type(type)
                            .styles(styles)
                            .projection(function (coord) {
                            var proj = methods.forward(coord);
                            return [proj[0] * multiplier, -proj[1] * multiplier];
                        })
                            .data(data)
                            .render();
                        return [4 /*yield*/, this.storeSVGInCache(shape, result)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return GeoIconWorker;
}());
exports.GeoIconWorker = GeoIconWorker;
exports.default = GeoIconWorker;
